import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSheet,{staticClass:"com-pc-card tm-mb-no-shadow",attrs:{"tile":"","height":_vm.height}},[_c(VRow,{ref:"damDiagWrapper",attrs:{"no-gutters":""}},[_c('div',[_c('div',{staticClass:"ma-1",attrs:{"id":"content-dam-diag","width":_vm.damDiagWidth,"height":_vm.damDiagHeight},domProps:{"innerHTML":_vm._s(_vm.getDamDiag)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }